// extracted by mini-css-extract-plugin
export default {"ya-map__metro":"FwnqBA","ya-map__metroIcon":"f6vsne"};